import { Component } from '@angular/core';
import {ViewEncapsulation} from '@angular/core';

import { TdIssuesService } from './../td-issues/td-issues.service';

@Component({
  selector: 'record-app',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss'],
  providers: [TdIssuesService],
  encapsulation: ViewEncapsulation.None
})
export class MainComponent {

  constructor() {

  }

  ngOnInit() {
  }
}


// WEBPACK FOOTER //
// ./admin/src/app/components/main/main.component.ts